module.exports = __webpack_public_path__ + "img/ledgers.closed.weekly.66e99d6a.png";